<div id="alert-dialog">
    <div class="alert-body">
      <div class="img-wrapper">
        <img *ngIf="status=='success'" src="./assets/icons/successful.svg" alt="">
        <img *ngIf="status=='error'" src="./assets/icons/Error.svg" alt="">
        <img *ngIf="status=='warn'" src="./assets/icons/something-went-wrong.svg" alt="">
      </div>
      <p class="title">{{title}}</p>
      <p class="sub-title">{{message}}</p>
      <div class="p-grid" *ngIf="hasRemark">
        <div class="input-group p-col-12">
            <input class="cust-input" type="text" placeholder="Remarks" [(ngModel)]="remarks" pInputText />
        </div>
        </div>
    </div>
    <div class="pt-5">
      <div class="cta">
        <button mat-raised-button [color]="btnClass" (click)="submit()">{{textOnBtn}}</button>
      </div>
    </div>
    <mat-icon class="close" (click)="dialogRef.close()">close</mat-icon>
  </div>